(ns ui.navbar
  "The navbar of the app's UI."
  (:require [parts.replicant.query :as query]
            [ui.campaign-banner]))

(defn overlay
  []
  [:div
   {:class ["fixed" "inset-0" "bg-black" "bg-opacity-50" "z-50" "flex" "items-center" "justify-center"]
    :on {:click [[:store/assoc :ui/logout-open? false]]}}])

(defn user-email
  [state]
  (or (get-in state
              [:user/session
               :user/email])
      (:user/email
        (query/get-result state
                          {:query/kind :query/user-session}))))

(defn user-menu-button
  ([state]
   (user-menu-button state {}))
  ([state {:keys [show-email? class email-class icon-class icon-margin-class]
           :or {show-email? true}}]
   (let [icon-margin-class (or icon-margin-class
                               (when show-email? ["ml-2"]))]
     [:div
      {:class (into ["flex" "items-center" "cursor-pointer"] class)
       :on {:click [[:store/assoc
                     :ui/logout-open?
                     (not (:ui/logout-open? state))]]}}
      (when show-email?
        (if email-class
          [:span {:class email-class} (user-email state)]
          [:span (user-email state)]))
      [:i
       {:class (into ["fas" "fa-user-circle" "fa-lg"]
                     (concat icon-margin-class
                             icon-class))}]])))

(defn logout-menu
  [state]
  (when (:ui/logout-open? state)
    (list
      (overlay)

      [:div
       {:style {:z-index "1000"}
        :class ["fixed" "bg-white" "ring-1" "rounded-md" "w-48" "ring-black" "ring-opacity-5" "right-0" "shadow-lg" "top-16" "py-1"]
        :role "menu"
        :aria-orientation "vertical"
        :aria-labelledby "user-menu-button"
        :tabIndex "-1"}

       [:a.block.px-4.py-2.text-sm.text-gray-700
        {:style {:display "flex"
                 :justify-content "flex-start"}
         :href "/logout/"}
        "Logout"]])))

(defn trial-user?
  "True when the session belongs to a start-credit trial user who never
   had a subscription. The navbar hides the ticking credit balance for
   them — it is not actionable without a subscription and only invites
   credit arithmetic — and shows an Upgrade button instead."
  [session]
  (boolean
    (and (:free-plan.trial/start-credit-amount session)
         (not (:subscription-id session))
         (not (:subscription-canceled session))
         (not (:organization/legacy-subscription-id session))
         (not (:organization/legacy-customer? session)))))

(defn campaign-banner
  "The eligible campaign under the navbar; on the wallet page as the
   button that opens the rates, elsewhere as the link to the wallet page."
  [state]
  (let [campaign (query/get-result state
                                   {:query/kind :query/campaign-eligible})
        ms-left (ui.campaign-banner/ms-until (:campaign/end-time campaign))]
    (when campaign
      (if (= :pages/subscription
             (get-in state [:location :location/page-id]))
        (ui.campaign-banner/rates-button campaign ms-left)
        (ui.campaign-banner/panel campaign ms-left)))))

(defn navbar
  [state]
  [:div
   [:nav.w-full.bg-storrito-500.shadow.flex.text-white.justify-between.items-center.mx-auto.px-4.sm:px-6.lg:px-8.h-16
    [:div.flex.items-center
     [:a.ml-10
      {:href "/"}
      [:img.h-8.w-auto
       {:src "/img/logo/storrito_light_vektor.svg"}]]
     (when (:organization/free-account?
             (query/get-result state
                               {:query/kind :query/user-session}))
       [:a
        {:href "/ui/agenda"
         :on {:click [[:store/assoc :ui.home.page/subscribe-skipped nil]]}
         :class ["bg-yellow-500" "rounded" "text-white" "py-1" "px-2" "ml-4" "font-bold" "text-sm" "whitespace-nowrap"
                 "hover:bg-yellow-400" "transition-colors" "cursor-pointer"]}
        "Free account"])]
    [:div.flex.items-center.h-full
     (when-let [current-state (query/get-result state
                                                {:query/kind :query/user-session})]
       (cond
         (and (trial-user? current-state)
              ;; Pointless while already on the subscription page, which
              ;; the button links to:
              (not= :pages/subscription
                    (get-in state [:location :location/page-id])))
         [:ui/a
          {:ui/location
           {:location/page-id :pages/subscription
            :location/params {}
            :location/query-params {:source "navbar"}}
           :class ["mr-4" "lg:mr-24" "bg-white" "text-storrito-600" "rounded-lg"
                   "px-3" "py-1.5" "text-sm" "font-semibold" "whitespace-nowrap"
                   "hover:bg-gray-100" "transition-colors" "hidden" "sm:block"]}
          "Upgrade"]

         (some? (:credit-balance current-state))
         [:ui/a.link
          {:ui/location
           {:location/page-id :pages/subscription
            :location/params {}
            :location/query-params {:source "navbar"}}
           :class ["mr-4" "lg:mr-24" "text-white" "whitespace-nowrap" "hover:text-gray-400"
                   "hidden" "sm:block"]
           }
          [:div "Credit Balance"]
          [:div
           (:credit-balance-formatted current-state)]]))
     (user-menu-button state)]

    (logout-menu state)]
   (campaign-banner state)])
